var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3C7.03125 3 3 7.03125 3 12C3 16.9688 7.03125 21 12 21C16.9688 21 21 16.9688 21 12C21 7.03125 16.9688 3 12 3Z",
    stroke: "#DEE2E6",
    strokeWidth: 1.8,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.60001 9.71654C9.60001 9.71654 9.63601 8.8766 10.4385 8.20311C10.915 7.80323 11.4873 7.68742 12 7.68029C12.4683 7.67444 12.8868 7.75512 13.137 7.87934C13.5647 8.09264 14.4 8.61189 14.4 9.71654C14.4 10.879 13.6705 11.4058 12.8413 11.9865C12.012 12.5671 11.8 13.1364 11.8 13.789",
    stroke: "#DEE2E6",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7818 16.4072C12.1835 16.4072 12.5091 16.0816 12.5091 15.68C12.5091 15.2783 12.1835 14.9527 11.7818 14.9527C11.3801 14.9527 11.0545 15.2783 11.0545 15.68C11.0545 16.0816 11.3801 16.4072 11.7818 16.4072Z",
    fill: "#DEE2E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.962e8becb58a73e458a47b3d2f687d21.svg";
export { ForwardRef as ReactComponent };